import type { PanelDrawing } from "@/features/drawings/panel/types";
import { listProjectDrawings, type ProjectDrawing } from "./api";

/**
 * 図面一覧の取り置き（react-query）。**同じキーには必ずこの取り方を使う**。
 *
 * タブの件数表示もここから引く。キーが同じで取り方だけ違うと、**先に走ったほうの
 * 形がキャッシュに残り**、あとから読む側が別の形を受け取る。実際にそれで、紐付け
 * 済みの図面がカードで「紐付無し」に見える不具合を出した（件数を出すだけの問い
 * 合わせが、下の写し替えを通らない生の応答でキャッシュを埋めていた）。
 */
export function projectDrawingsQuery(projectId: number) {
  return {
    queryKey: ["project-drawings", projectId] as const,
    queryFn: async (): Promise<{
      items: PanelDrawing[];
      unmatched_count: number;
    }> => {
      const res = await listProjectDrawings(projectId);
      return {
        items: res.items.map(toPanelDrawing),
        unmatched_count: res.unmatched_count,
      };
    },
  };
}
/** 案件の図面を、パネルが扱う中立な形へ写す。 */
function toPanelDrawing(drawing: ProjectDrawing): PanelDrawing {
  // 見積から引き継いだ図面は、案件側からは紐付けも削除もできない。
  const fromQuotation = drawing.quotation_number != null;
  return {
    ...drawing,
    item_id: drawing.project_item_id,
    origin_note: fromQuotation ? `見積 ${drawing.quotation_number} から引き継ぎ` : null,
    can_delete: !fromQuotation,
    can_relink: !fromQuotation,
    // 直すと見積側の図番まで変わる（同じ 1 行を共有している）。
    can_edit_number: !fromQuotation,
  };
}
